import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const TopicsSettingsComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "TopicsSettingsPage" */ "@circle-react/components/SettingsApp/Topics"
    ),
);

export const TopicsSettingsPage = () => (
  <Suspense fallback={<PageLoader />}>
    <TopicsSettingsComponent />
  </Suspense>
);
